document.addEventListener("DOMContentLoaded", function(event) {
  //let productFlavorsSelected = document.querySelector('.rtnu-pdp__flavors-list .selected-variant');
  
  //if (productFlavorsSelected) {
    //productFlavorsSelected.scrollIntoView({ block: 'end', inline: 'center' });
  //}

  function getElementPositionInScrollableParent(element, scrollableParent) {
      // Get the element's position relative to the viewport
      const elementRect = element.getBoundingClientRect();

      // Get the scrollable parent's position relative to the viewport
      const parentRect = scrollableParent.getBoundingClientRect();

      // Calculate the element's position relative to the scrollable parent's content area
      const relativeTop = elementRect.top - parentRect.top + scrollableParent.scrollTop;
      const relativeLeft = elementRect.left - parentRect.left + scrollableParent.scrollLeft;

      return {
          top: relativeTop,
          left: relativeLeft
      };
  }

  // Example usage:
  const scrollableDiv = document.querySelector('.rtnu-pdp__flavors-list');
  const targetElement = document.querySelector('.rtnu-pdp__flavors-list .selected-variant');

  if (scrollableDiv && targetElement) {
    let position = getElementPositionInScrollableParent(targetElement, scrollableDiv);
    scrollLeft = position.left - (window.innerWidth / 2.5);
    scrollableDiv.scrollBy({
      left: scrollLeft ,
      behavior: 'smooth' // Optional: for smooth scrolling animation
    });
  }

  // Select all container elements that hold the video
  const productVideoContainers = document.querySelectorAll('.rtnu-pdp__media-item-video');

  // Helper: pause all videos and remove 'is-playing' from all containers except the one specified
  function pauseOtherVideos(activeContainer) {
      productVideoContainers.forEach(container => {
          if (container !== activeContainer) {
              const videoElement = container.querySelector('video');
              if (videoElement && !videoElement.paused) {
                  videoElement.pause();
                  container.classList.remove('is-playing');
              }
          }
      });
  }

  // Add a click event listener to each video container
  productVideoContainers.forEach(container => {
      container.addEventListener('click', () => {
          const videoElement = container.querySelector('video');

          if (!videoElement) {
              console.warn("No video element found inside the container:", container);
              return;
          }

          if (videoElement.paused) {
              // Pause any other playing videos first
              pauseOtherVideos(container);

              // Play this video and add 'is-playing'
              videoElement.play().then(() => {
                  container.classList.add('is-playing');
              }).catch(error => {
                  console.error("Video play failed:", error);
              });
          } else {
              // Video is playing — pause it and remove 'is-playing'
              videoElement.pause();
              container.classList.remove('is-playing');
          }
      });
  });
});